/**
 * Confirm Resume Batch Modal Component
 * Confirmation dialog for clearing end date to resume a completed batch
 */

import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { DetailHeaderAction } from '../../../../../modules/shared/detail-page'

export interface ConfirmResumeBatchData {
    batchNumber?: string;
    equipmentName?: string;
}

@Component({
    selector: 'app-confirm-resume-batch-modal',
    templateUrl: './confirm-resume-batch-modal.component.html',
    styleUrls: ['./confirm-resume-batch-modal.component.scss'],
  standalone: false
})
export class ConfirmResumeBatchModalComponent {
    constructor(
        public dialogRef: MatDialogRef<ConfirmResumeBatchModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmResumeBatchData
    ) { }

    onCancel(): void {
        this.dialogRef.close(false);
    }

    onConfirm(): void {
        this.dialogRef.close(true);
    }

    /** Footer actions rendered by `<app-detail-action-bar flavor="material">`. */
    get footerActions(): DetailHeaderAction[] {
        return [
            {
                id: 'cancel',
                label: 'Cancel',
                tone: 'secondary',
                align: 'start'
            },
            {
                id: 'resume',
                label: 'Resume Job',
                matIcon: 'replay',
                tone: 'success'
            }
        ]
    }

    onFooterAction(a: DetailHeaderAction): void {
        if (a.id === 'cancel') this.onCancel()
        else if (a.id === 'resume') this.onConfirm()
    }
}
